/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Ad_Jobs_FoundInputs */



/**
* | output |
* | --- |
* | "No AD generation jobs found for the selected period." |
*
* @param {No_Ad_Jobs_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_ad_jobs_found = /** @type {((inputs?: No_Ad_Jobs_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Ad_Jobs_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune tâche de génération de publicités n'a été trouvée pour la période sélectionnée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für den ausgewählten Zeitraum wurden keine AD-Generierungsaufträge gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun processo di generazione di annunci pubblicitari trovato per il periodo selezionato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("За выбранный период не найдено заданий по генерации AD.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron trabajos de generación de AD para el período seleccionado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在所选时间段内未找到 AD 生成作业。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択した期間に該当するAD生成ジョブは見つかりませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित अवधि के लिए कोई विज्ञापन सृजन कार्य नहीं मिला।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foram encontradas tarefas de geração de anúncios de emprego para o período selecionado.")
	return /** @type {LocalizedString} */ ("No AD generation jobs found for the selected period.")
});